import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import DimensioningView from '../views/DimensioningView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  { path: '/dim', name: 'Dim', component: () => import(/* webpackChunkName: "dimensioning" */ '../views/DimensioningView.vue') },
  { path: '/qr', name: 'Qr', component: () => import(/* webpackChunkName: "qr" */ '../views/QrView.vue') },
  { path: '/ldk', name: 'LDK', component: () => import(/* webpackChunkName: "qr" */ '../views/LdkView.vue') },
  { path: '/uc', name: 'UnitCalculator', component: () => import(/* webpackChunkName: "qr" */ '../views/UnitCalculatorView.vue') },
  { path: '/canal', name: 'Canal', component: () => import(/* webpackChunkName: "qr" */ '../views/CanalView.vue') },
  { path: '/tube', name: 'Tube', component: () => import(/* webpackChunkName: "qr" */ '../views/TubeView.vue') },
  { path: '/airlpt', name: 'AirLPT', component: () => import(/* webpackChunkName: "qr" */ '../views/AirLPTView.vue') },
  { path: '/montage', name: 'Montage', component: () => import(/* webpackChunkName: "qr" */ '../views/MontageView.vue') },
  { path: '/imp', name: 'Impressum', component: () => import(/* webpackChunkName: "qr" */ '../views/ImpressumView.vue') }
]

const router = createRouter({
  history: createWebHashHistory(), 
  routes
})

export default router
